<template>
  <div class="user-msg msg-wrapper">
    <div class="msg-owner">USER</div>
    <div class="msg-content">
      {{msg.message.text}}
    </div>
  </div>
</template>
<script>
export default {
  props: ["msg"],
  data() {
    return {};
  },
  computed: {},
  created() {
    // console.log(this.msg, " user msg"); 
  }
};
</script>
<style lang="scss" scoped>
.msg-wrapper {
}
.msg-owner {
  margin-right: 1rem;
  color: #372fac;
}
</style>